import PropTypes from "prop-types"
import React from "react"

import Divider from "src/components/Divider"

const ContractSubmitted = ({ subtitle, title }) => {
  return (
    <div className="w-full">
      <div className="flex flex-col items-start gap-2 lg:flex-row-reverse lg:items-center lg:justify-end lg:gap-3">
        <i className="fa-solid fa-circle-check text-7xl text-teal-400" />
        <h1 className="m-0 text-[42px] font-bold leading-tight text-gray-900">
          {title}
        </h1>
      </div>
      <p className="mb-6 mt-2 text-base font-semibold text-gray-900">
        {subtitle}
      </p>
      <Divider />
    </div>
  )
}

ContractSubmitted.propTypes = {
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default ContractSubmitted
